import { MeasurementsStateType } from './state'
import { DeviceSample } from '../models/deviceSample'

export interface MeasurementsGettersType {
  getMeasurementById: (state: MeasurementsStateType, id: string) => DeviceSample | undefined
  
  getManagedMeasurements: (state: MeasurementsStateType) => DeviceSample[]
  getUnmanagedMeasurements: (state: MeasurementsStateType) => DeviceSample[]
  getRecentMeasurements: (state: MeasurementsStateType, days?: number) => DeviceSample[]
  totalMeasurements: (state: MeasurementsStateType) => number
  completedCount: (state: MeasurementsStateType) => number
  uncompletedCount: (state: MeasurementsStateType) => number
  completionRate: (state: MeasurementsStateType) => number
  pendingOldest: (state: MeasurementsStateType) => number
  averageResponseTime: (state: MeasurementsStateType) => number
}

export const MeasurementsGetters = {
  getMeasurementById: (state: MeasurementsStateType) => (id: string) => {
    return state.deviceSamples.find(deviceSample => deviceSample.id === id)
  },
  

  
  getManagedMeasurements: (state: MeasurementsStateType) => {
    return state.deviceSamples.filter(deviceSample => deviceSample.managed)
  },
  
  getUnmanagedMeasurements: (state: MeasurementsStateType) => {
    return state.deviceSamples.filter(deviceSample => !deviceSample.managed)
  },
  
  getRecentMeasurements: (state: MeasurementsStateType) => (days = 7) => {
    const daysAgo = new Date()
    daysAgo.setDate(daysAgo.getDate() - days)
    
    return state.deviceSamples.filter(deviceSample => 
      new Date(deviceSample.createdAt) >= daysAgo
    ).sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
  },

  // Computed getters for dashboard stats
  totalMeasurements: (state: MeasurementsStateType) => {
    return state.deviceSamples.length
  },

  completedCount: (state: MeasurementsStateType) => {
    return state.deviceSamples.filter(deviceSample => deviceSample.managed).length
  },

  uncompletedCount: (state: MeasurementsStateType) => {
    return state.deviceSamples.filter(deviceSample => !deviceSample.managed).length
  },

  completionRate: (state: MeasurementsStateType) => {
    const total = state.deviceSamples.length
    if (total === 0) return 0
    const completed = state.deviceSamples.filter(deviceSample => deviceSample.managed).length
    return Math.round((completed / total) * 100)
  },

  pendingOldest: (state: MeasurementsStateType) => {
    const unmanaged = state.deviceSamples.filter(deviceSample => !deviceSample.managed)
    if (unmanaged.length === 0) return 0
    
    const oldest = unmanaged.reduce((oldest, current) => 
      new Date(current.time) < new Date(oldest.time) ? current : oldest
    )
    
    const now = new Date()
    const diffTime = now.getTime() - new Date(oldest.time).getTime()
    return Math.floor(diffTime / (1000 * 60 * 60 * 24)) // days
  },

  averageResponseTime: (state: MeasurementsStateType) => {
    const managed = state.deviceSamples.filter(deviceSample => 
      deviceSample.managed && deviceSample.managedAt
    )
    
    if (managed.length === 0) return 0
    
    const totalHours = managed.reduce((sum, deviceSample) => {
      const created = new Date(deviceSample.createdAt).getTime()
      const managedTime = deviceSample.managedAt ? new Date(deviceSample.managedAt).getTime() : created
      const diffHours = (managedTime - created) / (1000 * 60 * 60)
      return sum + diffHours
    }, 0)
    
    return Math.round(totalHours / managed.length)
  },
}